module.exports = __webpack_public_path__ + "gy.136878327e3bbddac7c6.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gy.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gy.svg
// module chunks = styles